var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDetailsBtn },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.openPrint },
                        },
                        [_vm._v("打印")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_id",
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["id"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "id", $$v)
                                  },
                                  expression: "data.head['id']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_code",
                                attrs: {
                                  code: "code",
                                  name: "编号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["code"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "code", $$v)
                                  },
                                  expression: "data.head['code']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_storeId",
                                attrs: {
                                  code: "storeId",
                                  name: "门店ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["storeId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeId", $$v)
                                  },
                                  expression: "data.head['storeId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_positionId",
                                attrs: {
                                  code: "positionId",
                                  name: "药库ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionId", $$v)
                                  },
                                  expression: "data.head['positionId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_positionCode",
                                attrs: {
                                  code: "positionCode",
                                  name: "药库编号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionCode", $$v)
                                  },
                                  expression: "data.head['positionCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_positionName",
                                attrs: {
                                  code: "positionName",
                                  name: "药库名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionName", $$v)
                                  },
                                  expression: "data.head['positionName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_materielId",
                                attrs: {
                                  code: "materielId",
                                  name: "药品ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "materielId", $$v)
                                  },
                                  expression: "data.head['materielId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielCode",
                                attrs: {
                                  code: "materielCode",
                                  name: "药品编号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "materielCode", $$v)
                                  },
                                  expression: "data.head['materielCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielName",
                                attrs: {
                                  code: "materielName",
                                  name: "药品名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "materielName", $$v)
                                  },
                                  expression: "data.head['materielName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_medSpecId",
                                attrs: {
                                  code: "medSpecId",
                                  name: "供应商家ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["medSpecId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "medSpecId", $$v)
                                  },
                                  expression: "data.head['medSpecId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_medSpecCode",
                                attrs: {
                                  code: "medSpecCode",
                                  name: "供应商家编号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["medSpecCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "medSpecCode", $$v)
                                  },
                                  expression: "data.head['medSpecCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_medSpecName",
                                attrs: {
                                  code: "medSpecName",
                                  name: "供应商家名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["medSpecName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "medSpecName", $$v)
                                  },
                                  expression: "data.head['medSpecName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_medDosageId",
                                attrs: {
                                  code: "medDosageId",
                                  name: "生产商家ID",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["medDosageId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "medDosageId", $$v)
                                  },
                                  expression: "data.head['medDosageId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_medDosageCode",
                                attrs: {
                                  code: "medDosageCode",
                                  name: "生产商家编号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["medDosageCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "medDosageCode",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['medDosageCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_medDosageName",
                                attrs: {
                                  code: "medDosageName",
                                  name: "生产商家名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["medDosageName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "medDosageName",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['medDosageName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_qualitySign",
                                attrs: {
                                  code: "qualitySign",
                                  name: "品质标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.qualitySign),
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["qualitySign"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "qualitySign", $$v)
                                  },
                                  expression: "data.head['qualitySign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_batchCode",
                                attrs: {
                                  code: "batchCode",
                                  name: "批次号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["batchCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "batchCode", $$v)
                                  },
                                  expression: "data.head['batchCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_number",
                                attrs: {
                                  code: "number",
                                  name: "数量",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["number"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "number", $$v)
                                  },
                                  expression: "data.head['number']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_costPrice",
                                attrs: {
                                  code: "costPrice",
                                  name: "成本单价",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["costPrice"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "costPrice", $$v)
                                  },
                                  expression: "data.head['costPrice']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_costAmount",
                                attrs: {
                                  code: "costAmount",
                                  name: "成本金额",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["costAmount"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "costAmount", $$v)
                                  },
                                  expression: "data.head['costAmount']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_inventorySign",
                                attrs: {
                                  code: "inventorySign",
                                  name: "在库状态",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(
                                    _vm.jsonStr.inventorySign
                                  ),
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["inventorySign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "inventorySign",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['inventorySign']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_code",
                                            attrs: {
                                              code: "code",
                                              name: "编号",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["code"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['code']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_qualitySign",
                                            attrs: {
                                              code: "qualitySign",
                                              name: "品质标识",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.qualitySign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["qualitySign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "qualitySign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['qualitySign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_batchCode",
                                            attrs: {
                                              code: "batchCode",
                                              name: "批次号",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["batchCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "batchCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['batchCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_inventorySign",
                                            attrs: {
                                              code: "inventorySign",
                                              name: "在库状态",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.inventorySign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["inventorySign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "inventorySign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['inventorySign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_positionCode",
                                            attrs: {
                                              code: "positionCode",
                                              name: "药库编码",
                                              url: "clinic/inventory/inventory/position/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {
                                                storeCode: _vm.storeCode,
                                              },
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["positionCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "positionCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['positionCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_positionName",
                                            attrs: {
                                              code: "positionName",
                                              name: "药库名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["positionName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "positionName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['positionName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_materielCode",
                                            attrs: {
                                              code: "materielCode",
                                              name: "药品编号",
                                              url: "clinic/clinicdic/clinicmedicinedic/clinicmateriel/find/findPagination",
                                              "filed-list": [
                                                {
                                                  code: "materielCode",
                                                  name: "编码",
                                                },
                                                {
                                                  code: "materielName",
                                                  name: "名称",
                                                },
                                              ],
                                              "search-key": "materielName",
                                              searcher: {
                                                storeCode: _vm.storeCode,
                                                effectiveSign: "1",
                                              },
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["materielCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_materielName",
                                            attrs: {
                                              code: "materielName",
                                              name: "药品名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["materielName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_supplierCode",
                                            attrs: {
                                              code: "supplierCode",
                                              name: "供应商编号",
                                              url: "clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination",
                                              "filed-list": [
                                                {
                                                  code: "chainDictionaryCode",
                                                  name: "编码",
                                                },
                                                {
                                                  code: "chainDictionaryName",
                                                  name: "名称",
                                                },
                                              ],
                                              "search-key":
                                                "chainDictionaryName",
                                              searcher: {
                                                storeCode: _vm.storeCode,
                                                effectiveSign: "1",
                                                chainDirectoryCode: "GYS",
                                              },
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["supplierCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "supplierCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['supplierCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_supplierName",
                                            attrs: {
                                              code: "supplierName",
                                              name: "供应商名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["supplierName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "supplierName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['supplierName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_manufacturerCode",
                                            attrs: {
                                              code: "manufacturerCode",
                                              name: "生产商家编号",
                                              url: "clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination",
                                              "filed-list": [
                                                {
                                                  code: "chainDictionaryCode",
                                                  name: "编码",
                                                },
                                                {
                                                  code: "chainDictionaryName",
                                                  name: "名称",
                                                },
                                              ],
                                              "search-key":
                                                "chainDictionaryName",
                                              searcher: {
                                                storeCode: _vm.storeCode,
                                                effectiveSign: "1",
                                                chainDirectoryCode: "SCS",
                                              },
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "manufacturerCode"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "manufacturerCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['manufacturerCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_manufacturerName",
                                            attrs: {
                                              code: "manufacturerName",
                                              name: "生产商家名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "manufacturerName"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "manufacturerName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['manufacturerName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-id", {
                        attrs: { code: "id", name: "ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "code", name: "编号", edit: false },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "positionId",
                          name: "药库ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "positionCode",
                          name: "药库编号",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "positionName",
                          name: "药库名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "materielId",
                          name: "药品ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielCode",
                          name: "药品编号",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielName",
                          name: "药品名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: { code: "number", name: "数量", edit: false },
                      }),
                      _vm.$store.state.user.userRole == "STORE"
                        ? _c("ik-column-number", {
                            attrs: {
                              code: "costPrice",
                              name: "成本单价",
                              edit: false,
                            },
                          })
                        : _vm._e(),
                      _vm.$store.state.user.userRole == "STORE"
                        ? _c("ik-column-number", {
                            attrs: {
                              code: "costAmount",
                              name: "成本金额",
                              edit: false,
                            },
                          })
                        : _vm._e(),
                      _c("ik-column-id", {
                        attrs: {
                          code: "supplierId",
                          name: "供应商家ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "supplierCode",
                          name: "供应商家编号",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "supplierName",
                          name: "供应商家名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "manufacturerId",
                          name: "生产商家ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "manufacturerCode",
                          name: "生产商家编号",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "manufacturerName",
                          name: "生产商家名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "chandi", name: "产地", edit: false },
                        on: { onFieldChange: _vm.onBodyFieldChange },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "proDate",
                          name: "生产日期",
                          edit: false,
                        },
                        on: { onFieldChange: _vm.onBodyFieldChange },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "expirationNumber",
                          name: "保质期",
                          edit: false,
                        },
                        on: { onFieldChange: _vm.onBodyFieldChange },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "qualitySign",
                          name: "品质标识",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.qualitySign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "batchCode",
                          name: "批次号",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "inventorySign",
                          name: "在库状态",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.inventorySign),
                          edit: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c("InventoryP", { ref: "InventoryRef" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }